export default function initShowHint() {
    const items = document.querySelectorAll('.checkbox--hint');

    if (items.length) {
        items.forEach(item => {
            const icon = item.querySelector('.checkbox__notification-icon');
            if (icon) {
                icon.addEventListener('mouseenter', () => icon.classList.add('open'));
                icon.addEventListener('mouseleave', () => icon.classList.remove('open'));
            }

            const closeBtn = item.querySelector('.checkbox__notification-block-close');
            if (closeBtn) {
                closeBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    icon.classList.remove('open');
                })
            }

        })
    }
}


// WEBPACK FOOTER //
// ./src/js/showHint.js